var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.error.statusCode === 404)?_c('h1',[_vm._v("Pagina non trovata")]):(_vm.error.statusCode === 401)?_c('div',[_c('h1',[_vm._v("Accesso non consentito")]),_vm._v(" "),_c('nuxt-link',{staticClass:"link",attrs:{"to":"/dashboard"}},[_vm._v("Dashboard")])],1):_c('h1',[_vm._v("Si è verificato un errore")])])
}
var staticRenderFns = []

export { render, staticRenderFns }